import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './Star.scss'


const Star = ({ className, iconClassName, active, isBlack, isRed, onClick }) => {
  const rootClassName = cx(s.star, className)

  const composedIconCLassName = cx(s.icon, iconClassName, {
    [s.active]: active,
    [s.black]: isBlack,
    [s.red]: isRed,
  })

  const isClickable = typeof onClick === 'function'
  const adaProps = isClickable
    ? { role: 'button', tabIndex: 0 }
    : {}

  return (
    <div className={rootClassName} onClick={onClick} {...adaProps}>
      <svg viewBox="0 0 55.87 55.87" fill="currentColor" className={composedIconCLassName}>
        {/* eslint-disable-next-line max-len */}
        <path d="M55.82 21.58a1 1 0 00-.81-.68l-18.09-2.63-8.09-16.4a1 1 0 00-1.8 0l-8.08 16.4L.85 20.9a1 1 0 00-.55 1.7l13.1 12.76-3.1 18.02a1 1 0 001.45 1.06l16.18-8.51 16.18 8.5a1 1 0 001.45-1.05l-3.09-18.02 13.1-12.76a1 1 0 00.25-1.02z" />
      </svg>
    </div>
  )
}

Star.propTypes = {
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  active: PropTypes.bool,
  isBlack: PropTypes.bool,
  onClick: PropTypes.func,
}


export default Star
